
const Hero = () => {
  return (
    <section className="bg-banner bg-no-repeat bg-center bg-cover relative py-24 h-[700px] overflow-hidden flex items-center justify-end">
    <div className="flex flex-col gap-1 font-normal uppercase lg:mx-[20%]  mx-5">
      <span className=" md:text-6xl text-4xl md:tracking-[12px] tracking-wider" >NEW </span><br/>
      <span className="text-6xl md:text-7xl tracking-wider md:tracking-[12px]">COLLECTION </span>
  
  <button className="mt-8 bg-black text-white py-[0.3rem] max-w-[60%] tracking-wider">
shop now
  </button>
    </div>


    </section>
  )
}

export default Hero
